import { __rest, __assign, __makeTemplateObject } from 'tslib';
import React from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import { IconChevronLeft, IconChevronRight } from 'suomifi-icons';
import { SuomifiThemeConsumer } from '../../../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../../../theme/SuomifiTheme/SuomifiTheme.js';
import '../../../../theme/SpacingProvider/SpacingProvider.js';
import '../../../../../reset/HtmlA/HtmlA.js';
import '../../../../../reset/HtmlButton/HtmlButton.js';
import { HtmlDiv } from '../../../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../../../reset/HtmlH/HtmlH.js';
import '../../../../../reset/HtmlInput/HtmlInput.js';
import '../../../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../../../reset/HtmlLi/HtmlLi.js';
import '../../../../../reset/HtmlNav/HtmlNav.js';
import '../../../../../reset/HtmlOl/HtmlOl.js';
import '../../../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../../../../reset/HtmlUl/HtmlUl.js';
import '../../../../../reset/HtmlTable/HtmlTable.js';
import '../../../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../../../reset/HtmlTable/HtmlTableCell.js';
import { Dropdown } from '../../../Dropdown/Dropdown/Dropdown.js';
import { DropdownItem } from '../../../Dropdown/DropdownItem/DropdownItem.js';
import { baseStyles } from './DateSelectors.baseStyles.js';
import { Button } from '../../../../Button/Button.js';
import { yearOptions, monthOptions, monthIsSame, monthIsAfter, monthIsBefore, moveMonths } from '../../dateUtils.js';

var baseClassName = 'fi-date-selectors';
var selectorsClassNames = {
  baseClassName: baseClassName,
  container: "".concat(baseClassName, "_container"),
  yearSelect: "".concat(baseClassName, "_year-select"),
  monthSelect: "".concat(baseClassName, "_month-select"),
  buttons: "".concat(baseClassName, "_buttons"),
  monthButton: "".concat(baseClassName, "_month-button"),
  monthButtonIcon: "".concat(baseClassName, "_month-button_icon")
};
var BaseDateSelectors = function BaseDateSelectors(props) {
  var className = props.className,
    onChange = props.onChange,
    yearSelect = props.yearSelect,
    monthSelect = props.monthSelect,
    texts = props.texts,
    focusableDate = props.focusableDate,
    minDate = props.minDate,
    maxDate = props.maxDate;
  var handleYearSelect = function handleYearSelect(value) {
    var date = new Date(focusableDate);
    date.setFullYear(Number(value));
    if (monthIsAfter(date, maxDate)) {
      date = maxDate;
    } else if (monthIsBefore(date, minDate)) {
      date = minDate;
    }
    onChange(date);
  };
  var handleMonthSelect = function handleMonthSelect(value) {
    var date = new Date(focusableDate);
    date.setMonth(Number(value));
    onChange(date);
  };
  var handlePrevMonthButton = function handlePrevMonthButton() {
    var date = moveMonths(focusableDate, -1);
    onChange(date);
  };
  var handleNextMonthButton = function handleNextMonthButton() {
    var date = moveMonths(focusableDate, 1);
    onChange(date);
  };
  var getMonthNameByIndex = function getMonthNameByIndex(index) {
    if (index >= 0 && index <= 11) {
      return texts.monthNames[index];
    }
    return null;
  };
  var getPrevMonthButtonLabel = function getPrevMonthButtonLabel() {
    return "".concat(texts.prevMonthButtonLabel, " ").concat(getMonthNameByIndex(moveMonths(focusableDate, -1).getMonth()));
  };
  var getNextMonthButtonLabel = function getNextMonthButtonLabel() {
    return "".concat(texts.nextMonthButtonLabel, " ").concat(getMonthNameByIndex(moveMonths(focusableDate, 1).getMonth()));
  };
  return /*#__PURE__*/React.createElement(HtmlDiv, {
    className: classnames(className, selectorsClassNames.container)
  }, /*#__PURE__*/React.createElement(Dropdown, {
    forwardedRef: yearSelect,
    labelText: texts.yearSelectLabel,
    labelMode: "hidden",
    value: String(focusableDate.getFullYear()),
    onChange: handleYearSelect,
    className: selectorsClassNames.yearSelect,
    portal: false
  }, yearOptions(minDate, maxDate).map(function (year) {
    return /*#__PURE__*/React.createElement(DropdownItem, {
      value: String(year),
      key: year
    }, year);
  })), /*#__PURE__*/React.createElement(Dropdown, {
    forwardedRef: monthSelect,
    labelText: texts.monthSelectLabel,
    labelMode: "hidden",
    value: String(focusableDate.getMonth()),
    onChange: handleMonthSelect,
    className: selectorsClassNames.monthSelect,
    portal: false
  }, monthOptions(focusableDate, minDate, maxDate, texts).map(function (month) {
    return /*#__PURE__*/React.createElement(DropdownItem, {
      value: String(month.value),
      key: month.name
    }, month.name);
  })), /*#__PURE__*/React.createElement(HtmlDiv, {
    className: selectorsClassNames.buttons
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handlePrevMonthButton,
    variant: "secondaryNoBorder",
    "aria-label": getPrevMonthButtonLabel(),
    className: selectorsClassNames.monthButton,
    disabled: monthIsSame(focusableDate, minDate)
  }, /*#__PURE__*/React.createElement(IconChevronLeft, {
    className: selectorsClassNames.monthButtonIcon
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: handleNextMonthButton,
    variant: "secondaryNoBorder",
    "aria-label": getNextMonthButtonLabel(),
    className: selectorsClassNames.monthButton,
    disabled: monthIsSame(focusableDate, maxDate)
  }, /*#__PURE__*/React.createElement(IconChevronRight, {
    className: selectorsClassNames.monthButtonIcon
  }))));
};
var StyledDateSelectors = styled(function (_a) {
  _a.theme;
    var passProps = __rest(_a, ["theme"]);
  return /*#__PURE__*/React.createElement(BaseDateSelectors, __assign({}, passProps));
}).withConfig({
  componentId: "sc-1g0lkev-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    yearSelectWidth = _a.yearSelectWidth,
    monthSelectWidth = _a.monthSelectWidth;
  return baseStyles(theme, yearSelectWidth, monthSelectWidth);
});
var DateSelectors = function DateSelectors(props) {
  return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
    var suomifiTheme = _a.suomifiTheme;
    return /*#__PURE__*/React.createElement(StyledDateSelectors, __assign({
      theme: suomifiTheme
    }, props));
  });
};
DateSelectors.displayName = 'DateSelectors';
var templateObject_1;

export { BaseDateSelectors, DateSelectors, selectorsClassNames };
//# sourceMappingURL=DateSelectors.js.map
